import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import fixAdminMisc from './zh-CN/fix_adminmisc';
import fixBilling from './zh-CN/fix_billing';
import fixComponents from './zh-CN/fix_components';
import fixConsoleMisc from './zh-CN/fix_consolemisc';
import fixGap from './zh-CN/fix_gap';
import fixSystemconfig from './zh-CN/fix_systemconfig';
import fixTenant from './zh-CN/fix_tenant';
import fixVoiceClone from './zh-CN/fix_voiceclone';
import fixOpenapi from './zh-CN/fix_openapi';
import fixTodo from './zh-CN/fix_todo';
import fixLedger from './zh-CN/fix_ledger';
import fixFriend from './zh-CN/fix_friend';
import fixAdminFriendTpl from './zh-CN/fix_admin_friend_tpl';

export default {
  'navBar.lang': '����',
  'layout.user.link.help': '����',
  'layout.user.link.privacy': '��˽',
  'layout.user.link.terms': '����',
  'app.preview.down.block': '���ش�ҳ�浽������Ŀ',
  'app.welcome.link.fetch-blocks': '��ȡȫ������',
  'app.welcome.link.block-list': '���� block ���������ٹ�����׼ҳ��',

  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
  ...fixLedger,
  ...fixFriend,
  ...fixAdminFriendTpl,
};
